import type { DashboardUseCase } from "../../types/use-case.types"

import { BenefitBarChart } from "./benefit-bar-chart"
import { BusinessPainRadar } from "./business-pain-radar"
import { FeasibilityDonutChart } from "./feasibility-donut-chart"
import { FunctionCoverageChart } from "./function-coverage-chart"
import { ImplTimelineChart } from "./impl-timeline-chart"
import { InvestmentBenefitScatter } from "./investment-benefit-scatter"
import { SavingsSplitChart } from "./savings-split-chart"
import { StatusDonutChart } from "./status-donut-chart"
import { StrategicAlignmentDonut } from "./strategic-alignment-donut"
import { TenKRuleDonutChart } from "./ten-k-rule-donut-chart"

type DashboardChartsProps = {
  useCases: DashboardUseCase[]
}

export function DashboardCharts({ useCases }: DashboardChartsProps) {
  return (
    <div className="grid grid-cols-1 gap-6 lg:grid-cols-2">
      <BenefitBarChart useCases={useCases} />
      <StatusDonutChart useCases={useCases} />
      <TenKRuleDonutChart useCases={useCases} />
      <FeasibilityDonutChart useCases={useCases} />
      <BusinessPainRadar useCases={useCases} />
      <StrategicAlignmentDonut useCases={useCases} />
      <ImplTimelineChart useCases={useCases} />
      <InvestmentBenefitScatter useCases={useCases} />
      <SavingsSplitChart useCases={useCases} />
      <FunctionCoverageChart useCases={useCases} />
    </div>
  )
}
